export default {
  BASE: "/",
  ERROR: "/404",
  AUTH: "/auth",
  AUTH_REDIRECT: "/auth/:action(signin|signup|forgot-password)",
  AUTH_SUCESS_REDIRECT: "/auth/redirect_success",
  AUTH_SUCCESS: "/auth/success",
  AUTH_ERROR: "/auth/error",
  AUTH_LANDING: "/auth/landing",
  AUTH_SIGN_OUT: "/auth/signout",
};
